export const getClientTotal = data =>
  data?.reduce((acc, curr) => acc + curr.revenue_sum, 0);
